import script from "./NotePop.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotePop.vue?vue&type=script&setup=true&lang=ts"

import "./NotePop.vue?vue&type=style&index=0&id=f3d11ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3d11ade"]])

export default __exports__